import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { Calendar } from "@/components/ui/calendar";
import { Badge } from "@/components/ui/badge";

export default function CalendarPage() {
  const [actions, setActions] = useState([]);
  const [selected, setSelected] = useState(new Date());

  useEffect(() => {
    api.get("/actions").then(({ data }) => setActions(data));
  }, []);

  const byDate = useMemo(() => {
    const m = {};
    actions.forEach((a) => {
      if (!a.due_at) return;
      const k = new Date(a.due_at).toDateString();
      if (!m[k]) m[k] = [];
      m[k].push(a);
    });
    return m;
  }, [actions]);

  const dayActions = byDate[selected.toDateString()] || [];
  const markedDays = Object.keys(byDate).map((k) => new Date(k));

  return (
    <div className="p-8 lg:p-10 max-w-6xl">
      <div className="mb-10">
        <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-2">Calendrier</div>
        <h1 className="font-display text-4xl tracking-tight">Vos entretiens & relances</h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        <div className="border border-slate-200 bg-white p-4">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => d && setSelected(d)}
            modifiers={{ booked: markedDays }}
            modifiersClassNames={{ booked: "bg-blue-100 text-blue-900 font-bold" }}
            className="mx-auto"
          />
        </div>
        <div>
          <h2 className="font-display text-xl mb-4">{selected.toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "long" })}</h2>
          <div className="border border-slate-200 bg-white">
            {dayActions.length === 0 ? (
              <div className="p-6 text-sm text-slate-500">Aucun événement ce jour.</div>
            ) : (
              dayActions.map((a) => (
                <div key={a.id} className="p-4 border-b last:border-b-0 border-slate-100" data-testid={`cal-evt-${a.id}`}>
                  <div className="flex items-center gap-2 mb-1">
                    <Badge className="bg-slate-900 text-white hover:bg-slate-900 font-mono text-[10px] uppercase">{a.type}</Badge>
                    <span className="font-mono text-xs text-slate-500">{new Date(a.due_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                  </div>
                  <div className="font-medium">{a.title}</div>
                  <div className="text-xs text-slate-500">{a.candidate_name}</div>
                  {a.notes && <div className="text-xs text-slate-600 mt-1 italic">{a.notes}</div>}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
